export default class LoginModel {
  constructor(email, password) {
    this.email = email;
    this.password = password;
  }
}
